import config from '@/config/constants'
import _, { escapeRegExp } from 'lodash'
import Vue from 'vue'
import Observable from '@/utils/Observable'
import axios from 'axios'
import km, { listenRealtimeEvents, getAccessToken, resetEndpoints } from '../utils/pm2Io'
import { filterServerStatuses, parseBlacklist } from '@/store/utils/blacklist'
import DefaultMap from '../utils/DefaultMap'
import { bucketState as initialBucketState } from './initialState'
import throttleIdle from '@/utils/throttleIdle'
import moment from 'moment'
import pluralize from '@/filters/pluralize'
import { treeCorrectedForClockSkew, detailedTraceSummary } from '@/utils/zipkin'
import { DISPLAY_NOTIFICATION } from '@/store/modules/notifications'
import {
  FETCH_APPS,
  GET_APP,
  CREATE_APP,
  UPDATE_APP,
  DELETE_APP,
} from './modules/frontendApplications'
export { SUBMIT_CONTACT_INFOS } from '@/store/modules/pricingControl'
export { DISPLAY_NOTIFICATION }
export {
  TRIGGER_PM2_ACTION,
  TRIGGER_CUSTOM_ACTION,
  TRIGGER_CUSTOM_SCOPED_ACTION,
} from '@/store/modules/triggerAction'
export {
  FETCH_ALL_DASHBOARDS,
  CREATE_DASHBOARD,
  DELETE_DASHBOARD,
  UPDATE_DASHBOARD,
} from './modules/kpiDashboard'
export { FETCH_APPS, GET_APP, CREATE_APP, UPDATE_APP, DELETE_APP }

if (process.env.NODE_ENV === 'development') {
  // Make km globally accessible for debug
  window.km = km
}

export const FETCH_BUCKETS = 'FETCH_BUCKETS'
export const SET_CURRENT_BUCKET = 'SET_CURRENT_BUCKET'
// ISSUES
export const FETCH_ISSUES_SUMMARY = 'FETCH_ISSUES_SUMMARY'
export const LIST_ISSUES = 'LIST_ISSUES'
export const FETCH_ISSUES_HISTOGRAM = 'FETCH_ISSUES_HISTOGRAM'
export const FETCH_ISSUES_OCCURRENCES = 'FETCH_ISSUES_OCCURRENCES'
export const LIST_OCCURRENCES_FOR_IDENTIFIER = 'LIST_OCCURRENCES_FOR_IDENTIFIER'
export const LIST_OCCURRENCES_FOR_IDENTIFIER_V2 = 'LIST_OCCURRENCES_FOR_IDENTIFIER_V2'
export const FETCH_ISSUE = 'FETCH_ISSUE'
export const DELETE_ISSUES = 'DELETE_ISSUES'
export const DELETE_ISSUE = 'DELETE_ISSUE'
export const FETCH_REPLAY_SESSION = 'FETCH_REPLAY_SESSION'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_PLANS = 'FETCH_PLANS'
export const ACTIVATE_PM2 = 'ACTIVATE_PM2'
export const LOGOUT = 'LOGOUT'
// PROFILING
export const START_CPU_PROFILING = 'START_CPU_PROFILING'
export const STOP_CPU_PROFILING = 'STOP_CPU_PROFILING'
export const FETCH_CPU_PROFILE = 'FETCH_CPU_PROFILE'
export const START_HEAP_PROFILING = 'START_HEAP_PROFILING'
export const STOP_HEAP_PROFILING = 'STOP_HEAP_PROFILING'
export const FETCH_HEAP_PROFILE = 'FETCH_HEAP_PROFILE'
export const FETCH_PROFILING_HISTORY = 'FETCH_PROFILING_HISTORY'
export const RETRIEVE_PROFILING = 'RETRIEVE_PROFILING'
export const DOWNLOAD_PROFILING = 'DOWNLOAD_PROFILING'
export const DELETE_PROFILING = 'DELETE_PROFILING'
export const DISABLE_REALTIME = 'DISABLE_REALTIME'
//
export const FETCH_TOKENS = 'FETCH_TOKENS'
export const CREATE_TOKEN = 'CREATE_TOKEN'
export const DELETE_TOKEN = 'DELETE_TOKEN'
export const GET_OTP = 'GET_OTP'
export const ADD_OTP = 'ADD_OTP'
export const REMOVE_OTP = 'REMOVE_OTP'
export const FETCH_METRICS_AGGREGATIONS = 'FETCH_METRICS_AGGREGATIONS'
export const TAKE_MEM_SNAPSHOT = 'TAKE_MEM_SNAPSHOT'
export const SAVE_INFORMATIONS = 'SAVE_INFORMATIONS'
export const GET_NEW_PASSWORD = 'GET_NEW_PASSWORD'
export const ADD_PROVIDER = 'ADD_PROVIDER'
export const REMOVE_PROVIDER = 'REMOVE_PROVIDER'
export const SET_ALERT = 'SET_ALERT'
export const SET_SLACK = 'SET_SLACK'
export const SET_WEBHOOK = 'SET_WEBHOOK'
// BILLING
export const FETCH_BILLING_CARDS = 'FETCH_BILLING_CARDS'
export const ADD_BILLING_CARD = 'ADD_BILLING_CARD'
export const REMOVE_BILLING_CARD = 'REMOVE_BILLING_CARD'
export const SET_DEFAULT_BILLING_CARD = 'SET_DEFAULT_BILLING_CARD'
export const FETCH_BILLING_SUBSCRIPTION = 'FETCH_BILLING_SUBSCRIPTION'
export const FETCH_BILLING_SUBSCRIPTION_STATE = 'FETCH_BILLING_SUBSCRIPTION_STATE'
export const FETCH_BILLING_INVOICES = 'FETCH_BILLING_INVOICES'
export const FETCH_BILLING_RECEIPTS = 'FETCH_BILLING_RECEIPTS'
export const FETCH_BILLING_META = 'FETCH_BILLING_META'
export const UPDATE_BILLING_META = 'UPDATE_BILLING_META'
export const FETCH_BANK_ACCOUNT = 'FETCH_BANK_ACCOUNT'
export const ATTACH_BANK_ACCOUNT = 'ATTACH_BANK_ACCOUNT'
export const DELETE_BANK_ACCOUNT = 'DELETE_BANK_ACCOUNT'
//
export const SET_PREFERRED_METRICS = 'SET_PREFERRED_METRICS'
export const SET_SELECTED_VARIANCE = 'SET_SELECTED_VARIANCE'
export const CREATE_BUCKET = 'CREATE_BUCKET'
export const SUBSCRIBE_PLAN = 'SUBSCRIBE_PLAN'
export const PAYMENT_INTENT_SUCCEED = 'PAYMENT_INTENT_SUCCEED'
export const START_TRIAL = 'START_TRIAL'
export const INVITE_USER = 'INVITE_USER'
export const REMOVE_USER = 'REMOVE_USER'
export const CREATE_BUCKET_FLOW = 'CREATE_BUCKET_FLOW'
export const RETRIEVE_COUPON = 'RETRIEVE_COUPON'
export const RETRIEVE_VAT = 'RETRIEVE_VAT'
export const RETRIEVE_USERS = 'RETRIEVE_USERS'
export const SET_USER_NOTIFICATION = 'SET_USER_NOTIFICATION'
export const SET_USER_ROLE = 'SET_USER_ROLE'
export const REMOVE_INVITATION = 'REMOVE_INVITATION'
export const UPDATE_BUCKET = 'UPDATE_BUCKET'
export const DELETE_BUCKET = 'DELETE_BUCKET'
export const TRANSFER_BUCKET_OWNER = 'TRANSFER_BUCKET_OWNER'
export const COLLECT_LOGS = 'COLLECT_LOGS'
export const DELETE_SERVER = 'DELETE_SERVER'
export const FETCH_LOGS_HISTOGRAM = 'FETCH_LOGS_HISTOGRAM'
export const FETCH_LOGS = 'FETCH_LOGS'
export const SEND_FEEDBACK = 'SEND_FEEDBACK'
export const SHOULD_SHOW_FEEDBACK_POPUP = 'SHOULD_SHOW_FEEDBACK_POPUP'
export const SEND_CHURN_FEEDBACK = 'SEND_CHURN_FEEDBACK'
export const START_REALTIME_ISSUES = 'START_REALTIME_ISSUES'
export const STOP_REALTIME_ISSUES = 'STOP_REALTIME_ISSUES'
// ALERTING
export const FETCH_ALERTS = 'FETCH_ALERTS'
export const FETCH_ALERT = 'FETCH_ALERT'
export const CREATE_ALERT = 'CREATE_ALERT'
export const UPDATE_ALERT = 'UPDATE_ALERT'
export const DELETE_ALERT = 'DELETE_ALERT'
export const TRIGGER_SAMPLE_ALERT = 'TRIGGER_SAMPLE_ALERT'
export const DELETE_USER = 'DELETE_USER'
// ANOMALIES
export const FETCH_ANOMALIES = 'FETCH_ANOMALIES'
export const EDIT_ANOMALY_STATE = 'EDIT_ANOMALY_STATE'
export const UPDATE_ANOMALIES_CONFIG = 'UPDATE_ANOMALIES_CONFIG'
// METRICS
export const RETRIEVE_METRICS_LIST = 'RETRIEVE_METRICS_LIST'
// BUCKET CONFIG
export const UPDATE_BUCKET_CONFIGURATION = 'UPDATE_BUCKET_CONFIGURATION'
export const UPDATE_BUCKET_USER_OPTION = 'UPDATE_BUCKET_USER_OPTION'
export const IGNORE_ISSUES = 'IGNORE_ISSUES'
// TRACES
export const FETCH_TRACES = 'FETCH_TRACES'
export const FETCH_TRACE = 'FETCH_TRACE'
export const FETCH_TRACE_VALUES = 'FETCH_TRACE_VALUES'
export const FETCH_TRACE_TAGS = 'FETCH_TRACE_TAGS'
export const FETCH_TRACE_HISTOGRAM_BY_TAG = 'FETCH_TRACE_HISTOGRAM_BY_TAG'
// WEBCHECKS
export const FETCH_WEBCHECKS = 'FETCH_WEBCHECKS'
export const UPDATE_WEBCHECK = 'UPDATE_WEBCHECK'
export const FETCH_WEBCHECK = 'FETCH_WEBCHECK'
export const FETCH_WEBCHECKS_REGIONS = 'FETCH_WEBCHECKS_REGIONS'
export const CREATE_WEBCHECK = 'CREATE_WEBCHECK'
export const DELETE_WEBCHECK = 'DELETE_WEBCHECK'
export const FETCH_WEBCHECKS_METRICS_LIST = 'FETCH_WEBCHECKS_METRICS_LIST'
export const FETCH_WEBCHECKS_METRICS = 'FETCH_WEBCHECKS_METRICS'
// NOTIFICATIIONS
export const LIST_NOTIFICATIONS = 'LIST_NOTIFICATIONS'
export const RETRIEVE_NOTIFICATION = 'RETRIEVE_NOTIFICATION'
// MISC
export const RETRIEVE_CHANGELOG = 'RETRIEVE_CHANGELOG'
export const RETRIEVE_DEPLOYMENTS = 'RETRIEVE_DEPLOYMENTS'

// Map bucketId -> update to apply
const liveUpdatesBuffer = new DefaultMap(() => ({
  serverStatuses: new Map(), // Map server name -> newest server status
  blacklist: null,
}))

let removeRealtimeListeners
let removeRealtimeIssuesListener
window.isPerfMode = false

function triggerBlacklistEvent({ state, commit }, blacklist) {
  if (state.emittedEvents.includes('blacklist')) return
  if (blacklist.length < 6) return
  commit('ADD_EMITTED_EVENT', { event: 'blacklist' })
  Vue.ma.trackEvent({
    action: 'Process Number Exceeded',
    properties: {
      extraProcessCount: blacklist.length,
    },
  })
}

function updateBucket(
  { state, commit, getters },
  { bucketState, serverStatuses, frontendMetrics },
) {
  // Remove offline servers when auto delete offline server has activated
  serverStatuses = serverStatuses.filter(status => {
    if (
      status.data.server.active === true ||
      (status.data.server.active === false &&
        bucketState.bucket.configuration.auto_delete_offline_server !== true)
    ) {
      return true
    }
    commit('REMOVE_SERVER', { serverName: status.server_name })
    return false
  })

  const isFreshBucket = moment().diff(bucketState.bucket.created_at, 'd') <= 1
  if (!state.emittedEvents.includes('linked') && isFreshBucket) {
    commit('ADD_EMITTED_EVENT', { event: 'linked' })
    Vue.ma.trackEvent({
      action: 'Pm2 Runtime Linked',
    })
  }

  if (!state.emittedEvents.includes('app-started')) {
    commit('ADD_EMITTED_EVENT', { event: 'app-started' })
    Vue.ma.trackEvent({
      action: 'App Started',
    })
  }

  filterServerStatuses(bucketState.processBlacklist, serverStatuses)
  commit('SET_BUCKET', { bucketState, serverStatuses, frontendMetrics })
}

const updateBuckets = throttleIdle(({ dispatch, commit, getters, state }) => {
  const updates = Array.from(liveUpdatesBuffer)

  liveUpdatesBuffer.clear()

  updates.forEach(([bucketId, { serverStatuses, blacklist }]) => {
    const bucketState = state.buckets[bucketId]
    if (bucketState) {
      if (serverStatuses.size) {
        updateBucket(
          { state, commit, getters },
          { bucketState, serverStatuses: Array.from(serverStatuses.values()) },
        )
      }
      if (blacklist) {
        triggerBlacklistEvent({ state, commit }, blacklist)
        const currentBlacklist = getters.bucketById(bucketId).processBlacklist
        if (blacklist.length !== currentBlacklist.length) {
          dispatch(DISPLAY_NOTIFICATION, {
            type: 'info',
            message: `${pluralize(blacklist, '{} process is', '{} processes are')} ignored.`,
          })
        }
        commit('SET_PROCESS_BLACKLIST', { bucketId, blacklist })
      }
    }
  })
}, window.REFRESH_INTERVAL || 0)

function startRealtime(bucketId, { dispatch, commit, getters, state }) {
  var shown = false
  var elheart

  console.log('Realtime started')

  removeRealtimeListeners = listenRealtimeEvents(state.buckets[bucketId].bucket, {
    '*:status'(res) {
      if (window.isPerfMode == false) {
        if (!elheart) {
          elheart = document.getElementsByClassName('heartbeat')
        }
        if (shown == false && elheart) {
          if (elheart && elheart[0]) elheart[0].style.display = 'inline'
          shown = true
          setTimeout(() => {
            if (elheart && elheart[0]) elheart[0].style.display = 'none'
            shown = false
          }, 100)
        }
        window.REFRESH_INTERVAL = 0
      }

      if (window.VERBOSE === true) {
        console.log(res)
      }
      // If a new server sends a status, update the linked servers
      // This is needed in order to detect servers linked when they don't have processes
      if (!state.buckets[bucketId].serversLinked.includes(res.data.server.hostname)) {
        commit('ADD_LINKED_SERVER', { server: res.data.server.hostname, bucketId })
      }

      // If the server_name already exists on the map, then we show alert dialog
      if (
        state.buckets[bucketId].servers.find(
          server =>
            server.server_name === res.server_name &&
            (server.remote_ip !== res.data.server.remote_ip ||
             server.internal_ip !== res.internal_ip),
        )
      ) {
        commit('SET_DUPLICATE_SERVER', { serverName: res.server_name, ip: res.data.server.remote_ip })
      }

      // Push the raw realtime updates to the buffer
      liveUpdatesBuffer.get(bucketId).serverStatuses.set(res.server_name, res)
      // Launch a throttled worker to handle the buffer
      updateBuckets({ dispatch, commit, getters, state })
    },
    '*:mediator:blacklist'(res) {
      liveUpdatesBuffer.get(bucketId).blacklist = parseBlacklist(res)
      updateBuckets({ dispatch, commit, getters, state })
    },
  })
}

function stopRealtime(bucketId) {
  // Clear the realtime updates buffer
  liveUpdatesBuffer.delete(bucketId)
  // Cancel any postponed worker
  updateBuckets.cancel()
  // Unsubscribe from this bucket realtime updates
  km.realtime.unsubscribe(bucketId).catch(err => console.log(err))
}

function shouldUseMockData(getters, feature) {
  return !getters.hasFeature({ feature })
}

// TODO: make sure actions do not try to transform data structure, their only job is to fetch data and pass appropriate
// parts of it to mutations, this ensure that only mutations + getters need to be refactored if the state structure changes

// TODO: make sure most actions can take a bucketId as a parameter and use the one from route params if absent

// TODO: be sure to use the bucketId from params when commiting a result
export const actions = {
  [FETCH_BUCKETS]({ commit, state, getters }) {
    return km.bucket.retrieveAll().then(res => {
      res.data.forEach(bucket => {
        const bucketState = _.cloneDeep(initialBucketState)
        bucketState.bucket = bucket
        updateBucket({ state, commit, getters }, { bucketState, serverStatuses: [] })
      })
    })
  },

  [DISABLE_REALTIME]({ dispatch, commit, state, getters }, {}) {
    if (state.currentBucketId) stopRealtime(state.currentBucketId)
    window.isPerfMode = false
    window.REFRESH_INTERVAL = 0
  },

  [SET_CURRENT_BUCKET]({ dispatch, commit, state, getters }, { bucketId, force }) {
    if (state.currentBucketId === bucketId && !force) return
    if (state.currentBucketId) {
      stopRealtime(state.currentBucketId)
    }

    km.realtime.subscribe(bucketId).catch(err => console.log(err))

    return Promise.all([
      km.bucket.retrieve(bucketId),
      km.data.status.retrieve(bucketId),
      km.data.status.retrieveBlacklisted(bucketId),
      km.data.metrics.retrieveList(bucketId, { initiator: 'browser' }).catch(error => {
        // This call may fail if ES is down. It shouldn't block the loading of the bucket.
        console.error('Failed to retrieve frontend metrics list.', error)
        return { data: undefined }
      }),
      dispatch(FETCH_APPS, { bucketId }),
    ]).then(
      ([
        { data: bucket },
        { data: serverStatuses },
        { data: blacklist },
        { data: frontendMetrics },
      ]) => {
        blacklist = parseBlacklist(blacklist)

        const bucketState = _.cloneDeep(initialBucketState)
        bucketState.bucket = bucket
        bucketState.processBlacklist = blacklist
        triggerBlacklistEvent({ commit, state }, blacklist)
        commit('SET_CURRENT_BUCKET_ID', { bucketId })
        updateBucket({ state, commit, getters }, { bucketState, serverStatuses, frontendMetrics })

        if (serverStatuses.length > 100) {
          isPerfMode = true
          window.REFRESH_INTERVAL = 5000
        }
        setTimeout(() => {
          startRealtime(bucketId, { dispatch, commit, getters, state })
        }, 2000)
      },
    )
  },
  [FETCH_ISSUES_SUMMARY](
    { commit, state, getters },
    { bucketId = state.currentBucketId, aggregateBy },
  ) {
    if (shouldUseMockData(getters, 'exceptions')) return {}
    return km.data.issues.summary(bucketId, aggregateBy).then(res => res.data)
  },
  [LIST_ISSUES](
    { commit, state, getters },
    { bucketId = state.currentBucketId, app, server, source, initiator },
  ) {
    const promise = km.data.issues
      .list(bucketId, { app_name: app, server_name: server, source, initiator })
      .then(res => res.data)

    return promise
  },
  [FETCH_ISSUES_HISTOGRAM](
    { commit, state, getters },
    {
      bucketId = state.currentBucketId,
      source,
      initiator,
      app,
      start,
      end,
      interval,
      tags,
      invertedTags,
      identifier,
      includeFixed,
      includeEmptyDocs,
    },
  ) {
    const promise = km.data.issues
      .retrieveHistogram(bucketId, {
        app_name: app,
        identifier,
        source,
        initiator,
        interval,
        start,
        end,
        tags,
        invertedTags,
        includeFixed,
        includeEmptyDocs,
      })
      .then(res => res.data)

    return promise
  },
  [FETCH_ISSUES_OCCURRENCES](
    { commit, state, getters },
    { bucketId = state.currentBucketId, occurrenceId },
  ) {
    const promise = km.data.issues
      .findOccurences(bucketId, { occurrence_id: occurrenceId })
      .then(res => res.data)

    return promise
  },
  [LIST_OCCURRENCES_FOR_IDENTIFIER_V2](
    { commit, state, getters },
    { bucketId = state.currentBucketId, identifier, limit },
  ) {
    const promise = km.data.issues
      .findOccurences(bucketId, { identifier: identifier, limit: limit ? limit : 1, from: 100 })
      .then(res => res.data)

    return promise
  },
  [LIST_OCCURRENCES_FOR_IDENTIFIER](
    { commit, state, getters },
    { bucketId = state.currentBucketId, id, from },
  ) {
    const promise = km.data.issues
      .findOccurences(bucketId, { identifier: id })
      .then(res => res.data)

    return promise
  },
  [FETCH_ISSUE]({ commit, state }, { bucketId = state.currentBucketId, message }) {
    return km.data.issues.search(bucketId, { message })
  },
  [DELETE_ISSUES]({ commit, state, getters, dispatch }, { bucketId = state.currentBucketId, app }) {
    return km.data.issues.deleteAll(bucketId, app)
  },
  [DELETE_ISSUE](
    { commit, state, getters, dispatch },
    { bucketId = state.currentBucketId, id = state.route.params.issueId },
  ) {
    return km.data.issues.delete(bucketId, id)
  },
  [FETCH_REPLAY_SESSION](
    { commit, state, getters, dispatch },
    { bucketId = state.currentBucketId, uuid },
  ) {
    return km.data.issues.getReplay(bucketId, uuid).then(res => res.data)
  },
  [FETCH_USER]({ commit, state }) {
    return km.user.retrieve().then(res => {
      commit('SET_USER', { user: res.data })
      return res.data
    })
  },
  [FETCH_PLANS]({ commit, state }) {
    return km.misc.retrievePlans().then(res => {
      for (const id in res.data) {
        const plan = res.data[id]
        if (typeof plan !== 'object' || !plan.name) continue
        // Store the plan id in a 'id' property, because it can be different than the name, and the
        // API requires this instead of the name when specifying an plan.
        plan.id = id

        // Add some front-only features
        const isPlusOrMore = !plan.name.includes('free')
        plan.features.realtimeMetricsPage = true
        plan.features.realtimeIssuesPage = true
        plan.features.appsOverviewPage = isPlusOrMore
        plan.features.appDashboardPage = isPlusOrMore
        plan.features.realtimeLogsPage = isPlusOrMore
        plan.features.remoteActionsPage = isPlusOrMore
      }
      commit('SET_PLANS', { plans: res.data })
      return res.data
    })
  },
  [ACTIVATE_PM2]({ commit, dispatch, state, getters }, { position }) {
    if (!getters.currentBucket) {
      return dispatch(DISPLAY_NOTIFICATION, {
        type: 'error',
        message: 'You are not on a bucket page.',
      })
    }
    if (!getters.isUserOwner) {
      return dispatch(DISPLAY_NOTIFICATION, {
        type: 'error',
        message:
          'Contact your account admin to upgrade this bucket. Look for "Owner" in the team page.',
      })
    }
    commit('SET_ACTIVATE_PM2', { opened: true, position })
  },
  [LOGOUT]({ commit, state }) {
    return km.auth.logout()
  },
  [START_CPU_PROFILING](
    { commit, state, getters, dispatch },
    { id, server, bucketId = state.currentBucketId, opts },
  ) {
    if (shouldUseMockData(getters, 'profiling')) return
    const remoteCmd = {
      process_id: Number(id),
      server_name: server,
      action_name: 'km:cpu:profiling:start',
      opts,
    }

    if (opts !== undefined && isNaN(opts.timeout) === false) {
      const stopListening = listenRealtimeEvents(getters.currentBucket.bucket, {
        '*:profiling'(res) {
          if (window.VERBOSE === true) {
            console.log(res)
          }
          if (res.pm_id === id && res.server_name === server) {
            dispatch('FETCH_CPU_PROFILE', { dumpResource: res })
            stopListening()
          }
        },
      })
    }

    return km.actions.triggerAction(bucketId, remoteCmd)
  },
  [STOP_CPU_PROFILING](
    { commit, dispatch, state, getters },
    { id, server, bucketId = state.currentBucketId },
  ) {
    const remoteCmd = {
      process_id: Number(id),
      server_name: server,
      action_name: 'km:cpu:profiling:stop',
    }
    const stopListening = listenRealtimeEvents(getters.currentBucket.bucket, {
      '*:profiling'(res) {
        if (window.VERBOSE_PROFILING === true) {
          console.log(res)
        }
        if (res.pm_id === id && res.server_name === server) {
          dispatch('FETCH_CPU_PROFILE', { dumpResource: res })
          stopListening()
        }
      },
    })
    return km.actions.triggerAction(bucketId, remoteCmd)
  },
  [START_HEAP_PROFILING](
    { commit, state, getters, dispatch },
    { id, server, bucketId = state.currentBucketId, opts },
  ) {
    const remoteCmd = {
      process_id: Number(id),
      server_name: server,
      action_name: 'km:heap:sampling:start',
      opts,
    }

    if (opts !== undefined && isNaN(opts.timeout) === false) {
      const stopListening = listenRealtimeEvents(getters.currentBucket.bucket, {
        '*:profiling'(res) {
          if (res.pm_id === id && res.server_name === server) {
            dispatch('FETCH_HEAP_PROFILE', { dumpResource: res })
            stopListening()
          }
        },
      })
    }

    return km.actions.triggerAction(bucketId, remoteCmd)
  },
  [STOP_HEAP_PROFILING](
    { commit, dispatch, state, getters },
    { id, server, bucketId = state.currentBucketId },
  ) {
    const remoteCmd = {
      process_id: Number(id),
      server_name: server,
      action_name: 'km:heap:sampling:stop',
    }
    const stopListening = listenRealtimeEvents(getters.currentBucket.bucket, {
      '*:profiling'(res) {
        if (window.VERBOSE === true) {
          console.log(res)
        }
        if (res.pm_id === id && res.server_name === server) {
          dispatch('FETCH_HEAP_PROFILE', { dumpResource: res })
          stopListening()
        }
      },
    })
    return km.actions.triggerAction(bucketId, remoteCmd)
  },
  [FETCH_HEAP_PROFILE]({ commit, dispatch, state, getters }, { dumpResource }) {
    const fileUrl = `${dumpResource.filename}?access_token=${getAccessToken()}`
    const profile = {
      app: dumpResource.app_name,
      id: dumpResource.pm_id,
      server: dumpResource.server_name,
      fileUrl,
      fileSize: dumpResource.filesize,
    }
    const profiles = getters.currentBucket.ui.cpuProfilingPage.profiles
    const index = profiles.findIndex(p => p.app === profile.app && p.server === profile.server)
    if (index === -1) return commit('ADD_HEAP_PROFILE', { profile })
    commit('UPDATE_HEAP_PROFILE', { profile, index })
  },
  [FETCH_CPU_PROFILE]({ commit, dispatch, state, getters }, { dumpResource }) {
    const fileUrl = `${dumpResource.filename}?access_token=${getAccessToken()}`
    const processInfo = {
      app: dumpResource.app_name,
      id: dumpResource.pm_id,
      server: dumpResource.server_name,
      fileUrl,
      fileSize: dumpResource.filesize,
    }
    axios.get(fileUrl).then(res => {
      let profile = _.cloneDeep(res.data)
      profile = Object.assign(profile, processInfo)
      const profiles = getters.currentBucket.ui.cpuProfilingPage.profiles
      const index = profiles.findIndex(
        p => p.app === profile.app && p.server === profile.server && p.id === profile.id,
      )
      if (index === -1) return commit('ADD_CPU_PROFILE', { profile })
      commit('UPDATE_CPU_PROFILE', { profile, index })
    })
  },
  [FETCH_PROFILING_HISTORY](
    { state, commit, getters },
    { bucketId = state.currentBucketId, apps, servers, from, size, type },
  ) {
    return km.data.profiling
      .list(bucketId, {
        apps,
        servers,
        from,
        size,
        type,
      })
      .then(res => {
        let bucket = getters.bucketById(bucketId).bucket
        var nodeUri = bucket.node.endpoints.web || bucket.node.endpoints.realtime

        res.data.data.map(profiling => {
          profiling.fileUrl = `${nodeUri}${res.config.url}/${
            profiling.filename
          }/download?access_token=${getAccessToken()}`
        })
        commit('SET_PROFILING_HISTORY', { profilings: res.data })
        return res.data
      })
  },
  [RETRIEVE_PROFILING]({ state, commit, getters }, { bucketId = state.currentBucketId, filename }) {
    return km.data.profiling.retrieve(bucketId, filename).then(res => {
      return res.data
    })
  },
  [DOWNLOAD_PROFILING]({ state, commit }, { bucketId = state.currentBucketId, profiling }) {
    return km.data.profiling.download(bucketId, profiling.filename).then(res => {
      const processInfo = {
        app: profiling.process.name,
        id: profiling.process.pm_id,
        server: profiling.process.server,
        fileUrl: `${res.config.url}?access_token=${getAccessToken()}`,
        fileSize: res.data.lenth,
      }

      if (profiling.type === 'heapprofile') {
        commit('ADD_HEAP_PROFILE', { profile: processInfo })
        return res.data
      }

      let profile = _.cloneDeep(res.data)
      // Augment profile object with its corresponding process info
      profile = Object.assign(profile, processInfo)
      commit('ADD_CPU_PROFILE', { profile })
      return res.data
    })
  },
  [DELETE_PROFILING]({ state, commit }, { bucketId = state.currentBucketId, filename }) {
    return km.data.profiling.delete(bucketId, filename).then(res => {
      commit('DELETE_PROFILING', { filename })
      return res.data
    })
  },
  [FETCH_TOKENS]({ commit }) {
    return km.tokens.retrieve().then(res => {
      commit('SET_TOKENS', { tokens: res.data })
    })
  },
  [CREATE_TOKEN]({ commit }, { scope }) {
    return km.tokens.create({ scope }).then(res => {
      commit('ADD_TOKEN', { token: res.data })
    })
  },
  [DELETE_TOKEN]({ commit }, { id }) {
    return km.tokens.remove(id).then(res => {
      commit('REMOVE_TOKEN', { id })
    })
  },
  [GET_OTP]({ commit }) {
    return km.user.otp.retrieve.withoutErrorNotification().then(
      res => {
        commit('SET_OTP', {
          otp: res.data,
        })
      },
      error => {
        // The error 409 tells that there is no need to configure the OTP (a OTP is already
        // configured)
        if (error.status !== 409) {
          throw error
        }
      },
    )
  },
  [ADD_OTP]({ commit }, { key, code }) {
    return km.user.otp
      .enable({
        otpKey: key,
        otpToken: code,
      })
      .then(res => {
        commit('SET_OTP', { otp: {} })
      })
  },
  [REMOVE_OTP]({ dispatch }, { code }) {
    return km.user.otp.disable(code).then(res => {
      dispatch('GET_OTP')
    })
  },
  [FETCH_METRICS_AGGREGATIONS](
    { commit, state, getters },
    { aggregations, bucketId = state.currentBucketId },
  ) {
    return km.data.metrics
      .retrieveAggregations(bucketId, { aggregations: aggregations })
      .then(res => {
        return res.data
      })
  },
  [TAKE_MEM_SNAPSHOT](
    { commit, state, getters },
    { id, server, bucketId = state.currentBucketId },
  ) {
    const remoteCmd = {
      process_id: Number(id),
      server_name: server,
      action_name: 'km:heapdump',
    }
    const stopListening = listenRealtimeEvents(getters.currentBucket.bucket, {
      '*:profiling'(res) {
        if (res.dump_type !== 'heapdump' || res.pm_id !== id || res.server_name !== server) return
        stopListening()
        const snapshot = res
        const snapshots = getters.bucketById(bucketId).ui.memProfilingPage.snapshots
        const index = snapshots.findIndex(
          s => s.app_name === snapshot.app_name && s.server_name === snapshot.server_name,
        )
        snapshot.fileUrl = `${snapshot.filename}?access_token=${getAccessToken()}`
        if (index === -1) return commit('ADD_MEM_SNAPSHOT', { snapshot })
        commit('UPDATE_MEM_SNAPSHOT', { snapshot, index })
      },
    })
    return km.actions.triggerAction(bucketId, remoteCmd)
  },
  [SAVE_INFORMATIONS]({ commit }, { user }) {
    return km.user.update(user)
  },
  [GET_NEW_PASSWORD]({ dispatch, state }, { email = state.user.email }) {
    return km.auth.requestNewPassword({ email })
  },
  [ADD_PROVIDER]({ commit, state }, { name }) {
    return km.user.providers.add({ name }).then(res => {
      window.location = `${res.data.endpoint}?state=${res.data.state}`
    })
  },
  [REMOVE_PROVIDER]({ commit }, { name }) {
    return km.user.providers.remove(name).then(res => {
      commit('REMOVE_PROVIDER', { name })
    })
  },
  [SET_ALERT](
    { commit, state, getters },
    { bucketId = state.currentBucketId, name, active, duration, source, threshold },
  ) {
    const triggers = _.cloneDeep(getters.bucketById(bucketId).bucket.triggers)
    if (!triggers[name]) return
    triggers[name].active = active
    if (duration !== undefined) triggers[name].learning_duration = duration
    if (source !== undefined) triggers[name].source = source
    if (threshold !== undefined) triggers[name].threshold = threshold
    return km.bucket.alert.update(bucketId, { triggers }).then(res => {
      commit('UPDATE_ALERTS', { bucketId, triggers })
    })
  },
  [SET_SLACK]({ commit, state, getters }, { bucketId = state.currentBucketId, active, url }) {
    const slack = _.cloneDeep(getters.bucketById(bucketId).bucket.integrations.slack)
    if (active === true || active === false) slack.active = active
    if (url) slack.url = url
    return km.bucket.alert.updateSlack(bucketId, { slack }).then(res => {
      commit('UPDATE_SLACK', { bucketId, slack })
    })
  },
  [SET_WEBHOOK]({ commit, state, getters }, { bucketId = state.currentBucketId, active, url }) {
    const webhook = _.cloneDeep(getters.bucketById(bucketId).bucket.integrations.webhooks)
    if (active === true || active === false) webhook.active = active
    if (url) webhook.url = url
    return km.bucket.alert.updateWebhooks(bucketId, { webhooks: webhook }).then(res => {
      commit('UPDATE_WEBHOOK', { bucketId, webhook })
    })
  },
  [FETCH_BILLING_CARDS]({ commit, state }, { bucketId = state.currentBucketId }) {
    return Promise.all([
      km.bucket.billing.fetchCreditCards.withoutErrorNotification(bucketId),
      km.bucket.billing.fetchDefaultCreditCard.withoutErrorNotification(bucketId),
    ])
      .then(
        ([
          {
            data: { data: cards },
          },
          { data: defaultCard },
        ]) => {
          commit('SET_BILLING_CARDS', { bucketId, cards, defaultCard })
        },
      )
      .catch(error => {
        if (error && error.status === 404) {
          // No credit card found
          commit('SET_BILLING_CARDS', { bucketId, cards: [], defaultCard: null })
        } else {
          throw error
        }
      })
      .then(() => state.buckets[bucketId].billing.cards)
  },
  [ADD_BILLING_CARD]({ commit, state }, { bucketId = state.currentBucketId, token }) {
    return km.bucket.billing.attachCreditCard(bucketId, { token }).then(res => {
      commit('ADD_BILLING_CARD', { bucketId, card: res.data })
      return res.data
    })
  },
  [REMOVE_BILLING_CARD]({ commit, state }, { bucketId = state.currentBucketId, token }) {
    return km.bucket.billing.deleteCreditCard(bucketId, token).then(res => {
      commit('REMOVE_BILLING_CARD', { bucketId, token })
    })
  },
  [SET_DEFAULT_BILLING_CARD]({ commit, state }, { bucketId = state.currentBucketId, token }) {
    return km.bucket.billing.setDefaultCard(bucketId, token).then(res => {
      commit('SET_DEFAULT_BILLING_CARD', { bucketId, token })
    })
  },
  [FETCH_BILLING_SUBSCRIPTION]({ commit, state }, { bucketId = state.currentBucketId }) {
    return km.bucket.billing.getSubcription.withoutErrorNotification(bucketId).then(res => res.data)
  },
  [FETCH_BILLING_SUBSCRIPTION_STATE]({ commit, state }, { bucketId = state.currentBucketId }) {
    return km.bucket.billing.getSubcriptionState(bucketId).then(res => res.data)
  },
  [FETCH_BILLING_INVOICES]({ commit, state }, { bucketId = state.currentBucketId }) {
    return km.bucket.billing.getInvoices(bucketId).then(res => {
      commit('SET_BILLING_INVOICES', { bucketId, invoices: res.data.data })
    })
  },
  [FETCH_BILLING_RECEIPTS]({ commit, state }, { bucketId = state.currentBucketId }) {
    return km.bucket.billing.getReceipts(bucketId).then(res => {
      commit('SET_BILLING_RECEIPTS', {
        bucketId,
        receipts: res.data.data.map(charge => {
          charge.hyperlink = charge.invoice
            ? `${config.INVOICE_URL}/v1/invoice/${charge.invoice}`
            : undefined
          return charge
        }),
      })
    })
  },
  [FETCH_BILLING_META]({ commit, state }, { bucketId = state.currentBucketId }) {
    return km.bucket.billing.fetchMetadata(bucketId).then(res => {
      commit('SET_BILLING_META', { bucketId, meta: res.data })
    })
  },
  [SET_SELECTED_VARIANCE]({ commit, state }, value) {
    commit('SET_SELECTED_VARIANCE', { bucketId: state.currentBucketId, value })
  },
  [RETRIEVE_COUPON]({ state }, { coupon }) {
    return km.misc.retrieveCoupon({ coupon })
  },
  [CREATE_BUCKET]({ commit }, { name }) {
    return km.bucket.create({ name }).then(res => {
      return res.data
    })
  },
  [SEND_CHURN_FEEDBACK]({ state }, { bucketId = state.currentBucketId, feedback }) {
    return axios({
      url: 'https://hooks.zapier.com/hooks/catch/2939733/qf54do/',
      method: 'POST',
      data: JSON.stringify({ churn: feedback }),
      // The default 'transformRequest' behavior will add a 'Content-Type' header, but the request
      // fails with the error "Request header field Content-Type is not allowed by
      // Access-Control-Allow-Headers in preflight response." in this case. Just don't transform
      // anything.
      transformRequest: data => data,
    })
  },
  [SHOULD_SHOW_FEEDBACK_POPUP]({ state }) {
    return axios({
      url: 'https://kpi.internal.pm2.io/api/feedback/show_to_user',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({ email: state.user.email }),
    }).then(
      result => result.data && result.data.survey === true,
      () => false,
    )
  },
  [SEND_FEEDBACK]({ state }, { feedback }) {
    return axios({
      url: 'https://kpi.internal.pm2.io/api/feedback/new_feedback',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({ email: state.user.email, message: feedback }),
    })
  },
  [SUBSCRIBE_PLAN]({ state }, { bucketId = state.currentBucketId, plan, token, coupon }) {
    return km.bucket.billing
      .subscribe(bucketId, {
        plan,
        stripe_token: token,
        coupon_id: coupon,
      })
      .then(res => {
        return res.data
      })
  },
  [PAYMENT_INTENT_SUCCEED]({ state }, { bucketId = state.currentBucketId, paymentIntent }) {
    return km.bucket.billing.paymentIntentSucceed(bucketId, paymentIntent).then(res => res.data)
  },
  [START_TRIAL]({ state }, { bucketId = state.currentBucketId, plan }) {
    return km.bucket.billing.startTrial(bucketId, { plan }).then(res => {
      resetEndpoints()
      return res.data
    })
  },
  [INVITE_USER]({ state, commit }, { bucketId = state.currentBucketId, email }) {
    return km.bucket.inviteUser(bucketId, { email }).then(res => {
      if (res.data.invitations.length > 0) {
        commit('SET_INVITATIONS', { invitations: res.data.invitations })
      }
      return res.data
    })
  },
  [UPDATE_BILLING_META](
    { state },
    { bucketId = state.currentBucketId, vatNumber, companyName, receiptEmail },
  ) {
    return km.bucket.billing
      .updateMetadata(bucketId, {
        metadata: {
          vat_number: vatNumber,
          company_name: companyName,
          receipt_email: receiptEmail,
        },
      })
      .then(res => {
        return res.data
      })
  },
  [RETRIEVE_VAT]({ state, commit }, { bucketId = state.currentBucketId, country }) {
    return km.misc.retrieveVAT({ country }).then(res => {
      return res.data.standard_rate
    })
  },
  [RETRIEVE_USERS]({ state, commit }, { bucketId = state.currentBucketId }) {
    return km.bucket.retrieveUsers(bucketId).then(res => {
      if (bucketId === state.currentBucketId) {
        commit('SET_AUTHORIZED_USERS', { users: res.data, bucketId: bucketId })
      }
      return res
    })
  },
  [SET_USER_NOTIFICATION](
    { state, dispatch, commit },
    { bucketId = state.currentBucketId, email, notifState },
  ) {
    return km.bucket.setNotificationState(bucketId, { email, state: notifState }).then(res => {
      commit('SET_USER_NOTIFICATION', { email, notifState })
      dispatch('DISPLAY_NOTIFICATION', {
        type: 'success',
        message: 'Notifications has been updated',
      })
    })
  },
  [SET_USER_ROLE]({ state, dispatch, commit }, { bucketId = state.currentBucketId, email, role }) {
    return km.bucket.setUserRole(bucketId, { email, role }).then(res => {
      commit('SET_USER_ROLE', { email, role })
      dispatch('DISPLAY_NOTIFICATION', {
        type: 'success',
        message: 'Role has been updated',
      })
    })
  },
  [REMOVE_USER]({ state, commit }, { bucketId = state.currentBucketId, email }) {
    return km.bucket.removeUser(bucketId, { email }).then(res => {
      if (state.user.email === email) {
        commit('DELETE_BUCKET', { bucketId })
        if (bucketId === state.currentBucketId) {
          stopRealtime(bucketId)
        }
      } else {
        commit('REMOVE_AUTHORIZED_USER', { email })
      }
      return res.data
    })
  },
  [REMOVE_INVITATION]({ state, commit }, { bucketId = state.currentBucketId, email }) {
    return km.bucket.removeInvitation(bucketId, email).then(res => {
      commit('SET_INVITATIONS', { invitations: res.data.invitations })
    })
  },
  [UPDATE_BUCKET](
    { state, commit },
    { bucketId = state.currentBucketId, name, comment, configuration },
  ) {
    return km.bucket.update(bucketId, { name, comment, configuration }).then(res => {
      commit('UPDATE_BUCKET', { bucketId, bucket: res.data })
      return res.data
    })
  },
  [DELETE_BUCKET]({ state, commit }, { bucketId = state.currentBucketId }) {
    return km.bucket.destroy(bucketId).then(res => {
      commit('DELETE_BUCKET', { bucketId })
      if (bucketId === state.currentBucketId) {
        stopRealtime(bucketId)
      }
      return res.data
    })
  },
  [TRANSFER_BUCKET_OWNER](
    { state, commit, dispatch, getters },
    { bucketId = state.currentBucketId, newOwner },
  ) {
    return km.bucket.transferOwnership(bucketId, { new_owner: newOwner }).then(res => {
      const users = getters.authorizedUsers({ bucketId })
      const currentOwner = users.find(user => user.role === 'owner')
      if (currentOwner) {
        commit('SET_USER_ROLE', { email: currentOwner.email, role: 'admin' })
      }
      commit('SET_USER_ROLE', { email: newOwner, role: 'owner' })
      commit('UPDATE_BUCKET', { bucketId, bucket: res.data })
      dispatch('DISPLAY_NOTIFICATION', {
        type: 'success',
        message: 'Role has been updated',
      })
      return res.data
    })
  },
  async [COLLECT_LOGS](
    { state, commit, dispatch, getters },
    { bucketId = state.currentBucketId, serverName, appName },
  ) {
    function startLogging() {
      return km.actions.triggerPM2Action(bucketId, {
        method_name: 'startLogging',
        server_name: serverName,
        app_name: appName,
      })
    }

    await startLogging()

    return new Observable(observer => {
      // Keep starting logging every 100 seconds, because logging stops after 120 seconds
      const intervalId = setInterval(startLogging, 100000)

      const stopListening = listenRealtimeEvents(state.buckets[bucketId].bucket, {
        '*:logs'(res) {
          if (appName) {
            res = res.filter(
              log => log.process.name === appName && log.process.server === serverName,
            )
          }
          res.forEach(log => observer.next(log))
        },
      })

      return () => {
        km.actions.triggerPM2Action(bucketId, {
          method_name: 'stopLogging',
          server_name: serverName,
          app_name: appName,
        })

        stopListening()
        clearInterval(intervalId)
      }
    })
  },
  [DELETE_SERVER]({ state, commit }, { bucketId = state.currentBucketId, serverName }) {
    return km.bucket.server.deleteServer(bucketId, { server_name: serverName }).then(res => {
      commit('REMOVE_SERVER', { serverName })
    })
  },
  [FETCH_LOGS_HISTOGRAM](
    { state, getters },
    { bucketId = state.currentBucketId, appName, start, end, interval },
  ) {
    return km.data.logs
      .retrieveHistogram(bucketId, {
        app_name: appName,
        start,
        end,
        interval,
      })
      .then(r => r.data)
  },
  [FETCH_LOGS](
    { state, getters },
    { bucketId = state.currentBucketId, appName, serverName, before, after, size, from },
  ) {
    return km.data.logs
      .retrieve(bucketId, {
        app_name: appName,
        server_name: serverName,
        before,
        after,
        from,
      })
      .then(r => r.data)
  },
  [START_REALTIME_ISSUES]({ state, getters, commit }) {
    removeRealtimeIssuesListener = listenRealtimeEvents(getters.currentBucket.bucket, {
      '*:process:exception'(res) {
        commit('ADD_REALTIME_ISSUE', { issues: res })
      },
    })
  },
  [STOP_REALTIME_ISSUES]({ commit }) {
    commit('SET_REALTIME_ISSUES', { issues: [] })
    removeRealtimeIssuesListener()
  },
  [FETCH_ALERTS]({ state, commit }, { bucketId = state.currentBucketId }) {
    return km.bucket.alert.list(bucketId).then(res => {
      commit('SET_ALERTS', { alerts: res.data })
    })
  },
  [FETCH_ALERT]({ state, commit }, { bucketId = state.currentBucketId, alertId }) {
    return km.bucket.alert.get(bucketId, alertId).then(res => {
      return res.data
    })
  },
  [CREATE_ALERT]({ state, commit }, { bucketId = state.currentBucketId, alert }) {
    return km.bucket.alert.create(bucketId, alert).then(res => {
      commit('ADD_ALERT', { alert: res.data })
      return res.data
    })
  },
  [UPDATE_ALERT]({ state, commit }, { bucketId = state.currentBucketId, alert }) {
    return km.bucket.alert.updateAlert(bucketId, alert.id, alert).then(res => {
      commit('UPDATE_ALERT', { alert: res.data })
      return res.data
    })
  },
  [DELETE_ALERT]({ state, commit }, { bucketId = state.currentBucketId, alertId }) {
    return km.bucket.alert.delete(bucketId, alertId).then(res => {
      commit('DELETE_ALERT', { alertId: alertId })
    })
  },
  [TRIGGER_SAMPLE_ALERT]({ state, commit }, { bucketId = state.currentBucketId, alertId }) {
    return km.bucket.alert.triggerSample(bucketId, alertId)
  },
  [DELETE_USER]({ state, commit }) {
    return km.user.delete().then(res => {
      localStorage.removeItem('km_refresh_token')
      window.location.reload()
    })
  },
  [FETCH_ANOMALIES]({ state, commit }, { bucketId = state.currentBucketId, from = 0, size = 10 }) {
    return km.bucket.alert.analyzer
      .list(bucketId, {
        from: from,
        size: size,
      })
      .then(res => {
        commit('ADD_ANOMALIES', { anomalies: res.data })
        return res.data
      })
  },
  [EDIT_ANOMALY_STATE]({ state, commit }, { bucketId = state.currentBucketId, anomaly }) {
    return km.bucket.alert.analyzer
      .editState(bucketId, anomaly.id, {
        useful: anomaly.useful,
      })
      .then(res => {
        commit('UPDATE_ANOMALY', {
          anomaly: anomaly,
        })
      })
  },
  [UPDATE_ANOMALIES_CONFIG](
    { state, commit },
    { bucketId = state.currentBucketId, analyzerId, blacklist, threshold, window },
  ) {
    return km.bucket.alert.analyzer
      .updateConfig(bucketId, analyzerId, {
        blacklist: blacklist,
        threshold: threshold,
        window: window,
      })
      .then(res => {
        return res
      })
  },
  [FETCH_BANK_ACCOUNT]({ state }, { bucketId = state.currentBucketId }) {
    return km.bucket.billing.fetchBankAccount.withoutErrorNotification(bucketId).then(res => {
      return res.data
    })
  },
  [ATTACH_BANK_ACCOUNT]({ state }, { bucketId = state.currentBucketId, type, name, iban }) {
    return km.bucket.billing
      .attachBankAccount(bucketId, {
        type,
        name,
        iban,
      })
      .then(res => {
        return res.data
      })
  },
  [DELETE_BANK_ACCOUNT]({ state }, { bucketId = state.currentBucketId, type, name, iban }) {
    return km.bucket.billing.deleteBankAccount(bucketId).then(res => {
      return res.data
    })
  },
  [RETRIEVE_METRICS_LIST](
    { state, getters },
    { bucketId = state.currentBucketId, initiator, source, apps },
  ) {
    return km.data.metrics
      .retrieveList(bucketId, {
        initiator,
        source,
        apps,
      })
      .then(res => res.data)
  },
  [UPDATE_BUCKET_CONFIGURATION](
    { state, commit, getters },
    { bucketId = state.currentBucketId, option, value },
  ) {
    const configuration = _.cloneDeep(getters.bucketById(bucketId).bucket.configuration)
    configuration[option] = value
    return km.bucket.update(bucketId, { configuration }).then(res => {
      commit('UPDATE_BUCKET', { bucketId, bucket: res.data })
      return res.data
    })
  },
  [UPDATE_BUCKET_USER_OPTION](
    { state, commit, getters },
    { bucketId = state.currentBucketId, option, value },
  ) {
    const bucket = _.cloneDeep(getters.bucketById(bucketId).bucket)
    let options = _.get(bucket, `configuration.ui_options.user_options.${getters.user.id}`)
    if (options === undefined) options = {}
    options[option] = value

    return km.bucket.updateUserOptions(bucketId, { options }).then(res => {
      commit('UPDATE_BUCKET', { bucketId, bucket: res.data })
    })
  },
  [IGNORE_ISSUES](
    { state, commit, getters, dispatch },
    { bucketId = state.currentBucketId, messages },
  ) {
    const list = new Set(getters.bucketById(bucketId).bucket.configuration.ignored_issues)

    messages.forEach(message => list.add(escapeRegExp(message)))

    return dispatch(UPDATE_BUCKET_CONFIGURATION, {
      option: 'ignored_issues',
      value: Array.from(list),
    })
  },
  [FETCH_WEBCHECKS]({ state, commit }, { bucketId = state.currentBucketId, application } = {}) {
    return km.bucket.webcheck.list(bucketId, application).then(res => {
      commit('SET_WEBCHECKS', { webchecks: res.data })
      return res.data
    })
  },
  [UPDATE_WEBCHECK]({ state }, { bucketId = state.currentBucketId, webcheck }) {
    return km.bucket.webcheck.update(bucketId, webcheck.id, webcheck).then(res => {
      return res.data
    })
  },
  [FETCH_WEBCHECK]({ state }, { bucketId = state.currentBucketId, webcheckId }) {
    return km.bucket.webcheck.get(bucketId, webcheckId).then(res => {
      return res.data
    })
  },
  [FETCH_WEBCHECKS_REGIONS]({ state }, { bucketId = state.currentBucketId }) {
    return km.bucket.webcheck.listRegions(bucketId).then(res => {
      return res.data
    })
  },
  [CREATE_WEBCHECK]({ state }, { bucketId = state.currentBucketId, webcheck }) {
    return km.bucket.webcheck.create(bucketId, webcheck).then(res => {
      return res.data
    })
  },
  [UPDATE_WEBCHECK]({ state }, { bucketId = state.currentBucketId, webcheck }) {
    return km.bucket.webcheck.update(bucketId, webcheck.id, webcheck).then(res => {
      return res.data
    })
  },
  [DELETE_WEBCHECK]({ state }, { bucketId = state.currentBucketId, webcheckId }) {
    return km.bucket.webcheck.delete(bucketId, webcheckId).then(res => {
      return res.data
    })
  },
  [FETCH_WEBCHECKS_METRICS_LIST]({ state }, { bucketId = state.currentBucketId }) {
    return km.bucket.webcheck.listMetrics(bucketId).then(res => {
      return res.data
    })
  },
  [FETCH_WEBCHECKS_METRICS](
    { state },
    { bucketId = state.currentBucketId, webcheckId, start, end, metrics },
  ) {
    return km.bucket.webcheck
      .getMetrics(bucketId, webcheckId, {
        start,
        end,
        metrics,
      })
      .then(res => {
        return res.data
      })
  },
  [FETCH_TRACES]({ state }, { bucketId = state.currentBucketId, limit, ...params }) {
    return km.data.traces
      .list(bucketId, {
        ...params,
        includeSpans: false,
        limit: limit && String(limit),
      })
      .then(res => {
        if (!Array.isArray(res.data)) return []
        return res.data.map(({ id, root }) => ({
          id,
          summary: detailedTraceSummary(treeCorrectedForClockSkew([root])),
        }))
      })
  },
  [FETCH_TRACE]({ state }, { bucketId = state.currentBucketId, traceId }) {
    return km.data.traces.retrieve(bucketId, traceId).then(res => {
      return {
        id: traceId,
        summary: detailedTraceSummary(treeCorrectedForClockSkew(res.data)),
      }
    })
  },
  [FETCH_TRACE_VALUES]({ state }, { bucketId = state.currentBucketId } = {}) {
    return km.data.traces.getServices(bucketId).then(res => res.data)
  },
  [FETCH_TRACE_TAGS]({ state }, { bucketId = state.currentBucketId } = {}) {
    return km.data.traces.getTags(bucketId).then(res => res.data)
  },
  [FETCH_TRACE_HISTOGRAM_BY_TAG](
    { state },
    { bucketId = state.currentBucketId, tag, start, end, serviceName, spanName } = {},
  ) {
    return km.data.traces
      .getHistogramByTag(bucketId, { tag, start, end, serviceName, spanName })
      .then(res => res.data)
  },
  [LIST_NOTIFICATIONS](
    { state },
    { bucketId = state.currentBucketId, type, before, after, size, from, providers, contacts },
  ) {
    return km.data.notifications
      .list(bucketId, {
        type,
        before,
        after,
        size,
        from,
        providers,
        contacts,
      })
      .then(res => res.data)
  },
  [RETRIEVE_NOTIFICATION]({ state }, { bucketId = state.currentBucketId, notification }) {
    return km.data.notifications.list(bucketId, notification).then(res => res.data)
  },
  [RETRIEVE_CHANGELOG]({ state }, { page }) {
    return km.misc.listChangelogArticles({ page }).then(res => res.data)
  },
  [RETRIEVE_DEPLOYMENTS]({ state }, { appName, serverName }) {
    return km.data.processes
      .retrieveDeployments(state.currentBucketId, {
        server_name: serverName,
        app_name: appName,
      })
      .then(res => res.data)
  },
}
